<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title w-100 p-2 mb-0">
        <div class="row">
          <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="filter()" />
          </div>
          <div class="col-xl-3 col-12 fix-ng-select-clear" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [(ngModel)]="filterCustomer" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" (clear)="filterCustomer = {id: null, name: null}" [clearable]="!!filterCustomer.id" (ngModelChange)="filter()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{ "CUSTOMER" | translate }}: {{ !item.id ? ("ALL" | translate) : item.name }}</span>
              </ng-template>
              <ng-option [value]="customer" *ngFor="let customer of customers">
                <span class="font-small-4 font-weight-normal pr-2">{{ customer.name }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 col-12 fix-ng-select-clear" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [(ngModel)]="filterInvoiceType" (clear)="filterInvoiceType = {id: null, name: null}" [clearable]="!!filterInvoiceType.id" (ngModelChange)="filter()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{ "INVOICE_TYPE" | translate }}: {{ !item.id ? ("ALL" | translate) : item.name }}</span>
              </ng-template>
              <ng-option [value]="type" *ngFor="let type of invoice_document_types">
                <span class="font-small-4 font-weight-normal pr-2">{{ type.name }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 text-right" *ngIf="_utilService.isDesktop">
            <div [ngClass.xl]="'d-inline-block'" [ngClass.sm]="'d-none'">
              <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
            </div>
            <button type="button" class="btn btn-outline-primary ml-05" (click)="multiToggleInvoice(true)" *ngIf="!multiToggle">{{ "SELECT_ALL" | translate }}</button>
            <button type="button" class="btn btn-outline-primary ml-05" (click)="multiToggleInvoice(false)" *ngIf="multiToggle">{{ "DESELECT_ALL" | translate }}</button>
          </div>
          <div class="col-xl-2 col-12 mt-05">
            <label class="mb-0">{{ 'MONTH_OF_ISSUE' | translate }}</label>
            <select [(ngModel)]="filterMonth" class="form-control pr-3 text-capitalize" (ngModelChange)="filter()">
              <option selected disabled>{{ "MONTH" | translate }}</option>
              <option value="-1">{{ "ALL" | translate }}</option>
              <option *ngFor="let month of months; let i = index" [value]="i">{{ month }}</option>
            </select>
          </div>
          <div class="col-xl-2 col-12 mt-05">
            <label class="mb-0">{{ 'YEAR_OF_ISSUE' | translate }}</label>
            <select [(ngModel)]="filterYear" class="form-control pr-3" (ngModelChange)="filter()">
              <option selected disabled value="all">{{ "YEAR" | translate | titlecase }}</option>
              <option *ngFor="let year of years" [value]="year">{{ year }}</option>
            </select>
          </div>
          <div class="col-xl-8 text-right col-12 mt-075">
            <div class="btn-group mt-2" has_capability="send_invoice" *ngIf="idsToSend.length > 0">
              <div ngbDropdown>
                <button ngbDropdownToggle class="btn btn-outline-primary" type="button" id="dropdownMenuButton" rippleEffect>
                  {{ "SEND" | translate }}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                  <span ngbDropdownItem (click)="modalOpen($event, confirmSend, true)">Esolver</span>
                  <span ngbDropdownItem (click)="modalOpen($event, confirmSend, false)">{{ "SET_AS_SENDED" | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body px-0 py-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isDesktop ? 50 : 170"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="filteredListElements"
          [sorts]="[
            {prop: 'order_number', dir: 'desc' },
            {prop: 'has_client_approval', dir: 'desc'}
          ]">
          <ngx-datatable-column [name]="'ORDER_NUMBER' | translate" prop="order_number" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div class="mr-05 custom-control custom-checkbox">
                  <input [id]="'analytics' + row.id" [disabled]="!row.has_client_approval" type="checkbox" class="custom-control-input todo-checkbox" [checked]="idsToSend.includes(row.id)" #checkboxInvoice (change)="toggleInvoice(checkboxInvoice.checked, row)" />
                  <label [for]="'analytics' + row.id" class="custom-control-label cursor-pointer"></label>
                </div>
                <span>{{ row.order_number }}</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CUSTOMER' | translate" prop="client.name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a routerLink="/dashboard/customer/{{ row.client.id }}" target="_blank">{{ row.client.name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'RESOURCES' | translate" width="40" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <span class="mr-075" *ngIf="row.users_in_rows.length > 1" [ngbTooltip]="row.users_in_rows.join(', ')">
                  <i [data-feather]="'users'" size="19"></i>
                </span>
                <span class="mr-075" *ngIf="row.users_in_rows.length == 1" [ngbTooltip]="row.users_in_rows[0]">
                  <i [data-feather]="'user'" size="19"></i>
                </span>
                <span class="mr-075" *ngIf="row.products_in_rows.length > 0" [ngbTooltip]="row.products_in_rows.join(', ')">
                  <i [data-feather]="'package'" size="19"></i>
                </span>
                <span class="mr-075" *ngIf="row.users_in_rows.length < 1 && row.products_in_rows.length < 1 && row.rows" [ngbTooltip]="row.rows[0].description">
                  <i [data-feather]="'info'" size="19"></i>
                </span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'INVOICE_TYPE' | translate" prop="invoice_type.name" width="60" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.invoice_type.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'DOCUMENT_DATE' | translate" prop="document_date" width="40" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.document_date | date: "dd/MM/yyyy" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'EXPIRATION_DATE' | translate" prop="expiration_date" width="30" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.expiration_date | date: "dd/MM/yyyy" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'AMOUNT' | translate" prop="total_amount" width="30" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.invoice_type.name.toLowerCase().includes('di credito') ? '-' : '' }}{{ row.total_amount | currency: "EUR" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" width="30" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <ng-container *ngIf="row.workday_report_completed && row.order_number">
                  <button [ngbTooltip]="'ADD' | translate" *ngIf="!idsToSend.includes(row.id)" (click)="toggleInvoice(true, row)" type="button" class="bg-transparent border-0">
                    <i class="text-success" [data-feather]="'plus'" size="19"></i>
                  </button>
                  <button [ngbTooltip]="'REMOVE' | translate" *ngIf="idsToSend.includes(row.id)" (click)="toggleInvoice(false, row)" type="button" class="bg-transparent border-0">
                    <i class="text-warning" [data-feather]="'minus'" size="19"></i>
                  </button>
                </ng-container>
                <div *ngIf="!row.has_client_approval" class="text-warning mr-05 ml-05" [ngbTooltip]="'NEED_CLIENT_APPROVAL' | translate">
                  <i [data-feather]="'alert-triangle'" size="19"></i>
                </div>
                <div *ngIf="!row.order_number" class="text-warning mr-05 ml-05" [ngbTooltip]="'NEED_ORDER_NUMBER' | translate">
                  <i [data-feather]="'alert-triangle'" size="19"></i>
                </div>
                <button *ngIf="!row.is_credit_note" [ngbTooltip]="'EDIT' | translate" has_capability="edit_invoice" [routerLink]="['/dashboard/invoice/edit/invoice', row.id]" type="button" class="bg-transparent text-secondary border-0">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button *ngIf="row.is_credit_note" [ngbTooltip]="'EDIT' | translate" has_capability="edit_invoice" [routerLink]="['/dashboard/invoice/edit/credit-note', row.id]" type="button" class="bg-transparent text-secondary border-0">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button [ngbTooltip]="'DELETE' | translate" has_capability="delete_invoice" (click)="deleteInvoice(row)" type="button" class="bg-transparent text-danger border-0">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'INVOICE' | translate" width="700" [sortable]="false" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile align-items-center">
                <div class="col-12">
                  <strong>{{ "ORDER_NUMBER" | translate }}: </strong>
                  <span>{{ row.order_number }}</span>
                </div>
                <div class="col-12">
                  <strong>{{ "CUSTOMER" | translate }}: </strong>
                  <a routerLink="/dashboard/customer/{{ row.client.id }}" target="_blank">{{ row.client.name }}</a>
                </div>
                <div class="col-12">
                  <strong>{{ "INSERTED_BY" | translate }}: </strong>
                  <a [routerLink]="'/dashboard/user/profile/' + row.created_by?.hash" target="_blank">{{ row.created_by?.complete_name }}</a>
                </div>
                <div class="col-12">
                  <strong>{{ "DOCUMENT_DATE" | translate }}: </strong>
                  <span>{{ row.document_date | date: "dd/MM/yyyy" }}</span>
                </div>
                <div class="col-12">
                  <strong>{{ "EXPIRATION_DATE" | translate }}: </strong>
                  <span>{{ row.expiration_date | date: "dd/MM/yyyy" }}</span>
                </div>
                <div class="col-12">
                  <strong>{{ "AMOUNT" | translate }}: </strong>
                  <span>{{ row.total_amount | currency: "EUR" }}</span>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
        <h4 class="px-2 pb-1 pt-2">{{ 'SUM_ESTIMATED_REVENUE' | translate }}: {{ sumTotalsAmount | currency: 'EUR' }}</h4>
      </div>
    </div>
  </div>
</div>
<ng-template #confirmSend let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modalClose()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <div class="d-flex align-items-center justify-content-center mb-1">
      <span class="text-danger"><i data-feather="alert-triangle" size="30"></i></span>
      <h1 class="text-center text-danger mx-1 mb-0">{{ "ALERT.ALERT_TITLE" | translate }}</h1>
      <span class="text-danger"><i data-feather="alert-triangle" size="30"></i></span>
    </div>
    <p class="text-center mb-0" *ngIf="sendingToEsolver">{{ "YOU_ARE_SENDING" | translate }} {{ idsToSend.length }} {{ "INVOICES_TO" | translate }} eSolver.</p>
    <p class="text-center mb-0" *ngIf="!sendingToEsolver">{{ "YOU_ARE_SETTING" | translate }} {{ idsToSend.length }} {{ (idsToSend.length > 1 ? 'INVOICES_TO_SENDED_PLURAL' : "INVOICES_TO_SENDED") | translate }}.</p>
    <p class="text-center mb-0">{{ "ALERT.CONFIRM_DELETE_TITLE" | translate }}</p>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()" rippleEffect>{{ "CANCEL" | translate }}</button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="updateStatus()">{{ "SEND" | translate }}</button>
  </div>
</ng-template>
<!-- / Modal -->
